import Head from 'next/head';
import React from 'react';

export type Props = {
  title?: string;
  canonicalUrl?: string;
};

export default function SEO(props: Props) {
  let { title, canonicalUrl } = props;

  return (
    <Head>
      <title>Viresmo{title && ` - ${title}`}</title>
      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
    </Head>
  );
}
